import axiosInstance from "../axiosClient";

export const getConsultantsByBalance = async (params = {}) => {
  return axiosInstance.get("admins/consultants_by_balance", { params });
};

export const withdrawConsultantBalance = async (payload) => {
  // payload: { id, amount, description?, reference_id? }
  return axiosInstance.post("admins/withdraw_consultant_balance", payload);
};

export const getConsultantSettlements = async (consultant_id, params = {}) => {
  return axiosInstance.get("admins/consultant_settlements", {
    params: { consultant_id, ...params },
  });
};

export const getAllSettlements = async (params = {}) => {
  return axiosInstance.get("admins/settlements", { params });
};

// One-click RazorpayX payout: creates the payout to the consultant's UPI/bank.
// Balance is debited automatically when the payout succeeds (webhook), so the
// request moves pending → processing → completed on its own.
export const payoutWithdrawal = async (payload) => {
  // payload: { settlement_id }
  return axiosInstance.post("admins/payout_withdrawal", payload);
};

// Consultant-initiated withdrawal requests land as pending Settlement rows
// (status: "pending"). The admin pays out the money (via RazorpayX / bank) and
// then marks the request paid — the balance was already held at request time.
export const markWithdrawalPaid = async (payload) => {
  // payload: { settlement_id, reference_id }
  return axiosInstance.post("admins/mark_withdrawal_paid", payload);
};

// Reject a pending request — credits the held amount back to the consultant.
export const rejectWithdrawal = async (payload) => {
  // payload: { settlement_id, reason? }
  return axiosInstance.post("admins/reject_withdrawal", payload);
};
